import axios, {AxiosRequestConfig, AxiosResponse} from "axios"
import {vue} from "@/main"
import appConfig from "@/config"

export const api = axios.create()

export function loadAuth() {
  let sso = vue.$store.state.sso
  if (!vue.$store.state.sso.userId && typeof sessionStorage !== "undefined") {
    const sessionId = sessionStorage.getItem("sessionId")
    const userId = parseInt(sessionStorage.getItem("userId") || "0", 10)
    sso = {userId, sessionId}
    vue.$store.commit("setSSO", sso)
  }
  const exp = new Date()
  exp.setHours(exp.getHours() + 24)
  document.cookie = "SESSIONID" + "=" + encodeURIComponent(sso.sessionId) + "; expires=" + exp.toUTCString() + "; path=/api/; SameSite=Strict;"
  return sso
}

export function logout() {
  sessionStorage.removeItem("sessionId")
  sessionStorage.removeItem("userId")
  vue.$store.commit("setSSO", {userId: 0, sessionId: null})
  delete api.defaults.headers.Authorization
  window.location = (appConfig.AUTH_LOGOUT_URL + "?returnUrl=" + appConfig.BASE_URL) as unknown as Location
}

export function getAuthHeader(): string | null {
  // if token in state is null load it from browser session storage
  const sso = loadAuth()
  return sso.sessionId ? "Bearer " + sso.sessionId : null
}

api.interceptors.request.use((r: AxiosRequestConfig): AxiosRequestConfig => {
  const ah = getAuthHeader()
  r.baseURL = appConfig.AUTH_API_URL
  if (ah !== null) {
    r.headers.Authorization = getAuthHeader()
  }
  return r
})

api.interceptors.response.use((response: AxiosResponse<any>): AxiosResponse<any> => {
  return response
}, (err) => {
  if (err.response === undefined) {
    console.log("Error response: ", err)
  }
  if (err.response.status === 400 || err.response.status === 401) { // ToDo: remove 400 when server is fixed
    console.log("error code", err.response.status)
    authenticate()
  } else if (err.response.status > 499 && err.response.status < 600) {
    if (err.response.data !== undefined && err.response.data.errorMessage !== undefined) {
      console.log("auth request failed", err.response.data.errorMessage)
    } else {
      console.log("auth request failed", err.response.statusText)
    }
  }
})

export function updateToken(sso: { userId: number, sessionId: string }) {
  api.defaults.headers.Authorization = "Bearer " + sso.sessionId
  sessionStorage.setItem("sessionId", sso.sessionId)
  sessionStorage.setItem("userId", String(sso.userId))
  console.log("updated token")
}

export function authenticate(returnPath: string = vue.$router.currentRoute.fullPath) {
  let authURL = appConfig.AUTH_URL
  authURL = authURL.replace("AUTH_CALLBACK_URL", encodeURIComponent(appConfig.AUTH_CALLBACK_URL))
  authURL = authURL.replace("PAGE_RETURN_URL", encodeURIComponent(returnPath))
  window.location.href = authURL
}
